import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const comparisonRows = [
  { label: 'Onboarding Fee', vendor: '$2,500 one-time', partner: 'Waived', partnerGood: true },
  { label: 'Monthly Base Fee', vendor: '$250 / provider', partner: 'Waived', partnerGood: true },
  { label: 'Ops Revenue Share', vendor: '2.5% of net collections', partner: '0% — None', partnerGood: true },
  { label: 'RCM Add-on', vendor: '+2.5% (optional)', partner: '0% — None', partnerGood: true },
  { label: 'MSO Equity', vendor: 'None', partner: '40% ownership', partnerGood: true },
  { label: 'Compensation Package', vendor: 'Keep all collections minus fees', partner: '$500K guaranteed annual pay', partnerGood: true },
  { label: 'Practice Ownership', vendor: '100% retained', partner: '100% retained', partnerGood: false },
  { label: 'Clinical Autonomy', vendor: 'Full', partner: 'Full', partnerGood: false },
  { label: 'Admin Burden', vendor: 'Reduced via MSO', partner: 'Fully eliminated', partnerGood: true },
  { label: 'Best For', vendor: 'Groups, multi-provider, specialty clinics', partner: 'Single-practice physicians', partnerGood: false },
];

export default function PricingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-gradient-to-b from-[#0A1628] to-[#1B4B7F]'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/6f24c25eed393f63407e0e21645fee7d.png" alt="MedxMSO Logo" className="h-12 w-auto" />
              <span className={`text-xl font-black tracking-tight whitespace-nowrap ${scrolled ? 'text-[#1B4B7F]' : 'text-white'}`}>MedxMSO</span>
            </Link>
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Home</Link>
              <Link to="/services" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Services</Link>
              <Link to="/pricing" className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#1B4B7F]' : 'text-white'}`}>Models</Link>
              <Link to="/mso-pricing" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Vendor Pricing</Link>
              <Link to="/partnership" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#059669] hover:text-[#047857]' : 'text-[#6EE7B7] hover:text-white'}`}>Partnership</Link>
              <Link to="/why-mso" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Why MSO?</Link>
              <Link to="/audit" className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#BE185D] hover:text-[#9D174D]' : 'text-[#F9A8D4] hover:text-white'}`}>Request Audit</Link>
              <Link to="/#contact" className={`px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'bg-[#1B4B7F] text-white hover:bg-[#153a63]' : 'bg-white/20 border border-white/40 text-white hover:bg-white/30'}`}>
                Get Started
              </Link>
            </div>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="px-6 py-4 space-y-3">
              <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Home</Link>
              <Link to="/services" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Services</Link>
              <Link to="/pricing" className="block text-sm font-semibold text-[#1B4B7F] cursor-pointer">Models</Link>
              <Link to="/mso-pricing" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Vendor Pricing</Link>
              <Link to="/partnership" className="block text-sm font-semibold text-[#059669] cursor-pointer">Partnership</Link>
              <Link to="/why-mso" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Why MSO?</Link>
              <Link to="/audit" className="block text-sm font-semibold text-[#BE185D] cursor-pointer">Request Audit</Link>
              <Link to="/#contact" className="block bg-[#1B4B7F] text-white px-6 py-2.5 rounded-full text-sm font-medium text-center hover:bg-[#153a63] transition-colors cursor-pointer">Get Started</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="pt-36 pb-16 bg-gradient-to-b from-[#F0F7FF] to-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-xs uppercase tracking-[3px] text-[#0D9488] mb-4 font-semibold">TWO PATHS. ONE MISSION.</p>
          <h1 className="text-6xl lg:text-7xl font-black text-gray-900 leading-tight mb-6">Choose Your Model</h1>
          <p className="text-xl text-gray-600 leading-relaxed mb-8 max-w-2xl mx-auto">
            MedxMSO offers two distinct engagement models. Both protect your clinical independence completely — the difference is how deep you want to go.
          </p>
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-2.5 rounded-full text-sm font-semibold text-gray-700">
            <i className="ri-shield-check-line text-[#0D9488] text-lg"></i>
            Clinical decisions remain 100% with providers — in both models
          </div>
        </div>
      </section>

      {/* Two Model Cards */}
      <section className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">

            {/* Vendor Model */}
            <div className="rounded-3xl border-2 border-[#1B4B7F] p-10 relative flex flex-col">
              <div className="absolute -top-4 left-8 bg-[#1B4B7F] text-white px-5 py-1.5 rounded-full text-xs font-bold tracking-widest">
                TRACK 1 — MSO VENDOR
              </div>
              <div className="mb-6">
                <div className="w-14 h-14 bg-[#1B4B7F]/10 rounded-2xl flex items-center justify-center mb-5">
                  <i className="ri-briefcase-line text-[#1B4B7F] text-3xl"></i>
                </div>
                <h2 className="text-3xl font-black text-gray-900 mb-3">MSO as Your Vendor</h2>
                <p className="text-gray-600 leading-relaxed">
                  Hire MedxMSO to handle all your administrative operations. You stay fully independent, keep all your practice economics, and pay only a small performance-based fee.
                </p>
              </div>

              <div className="space-y-3 mb-8 flex-1">
                {[
                  '$2,500 one-time onboarding',
                  '$250 / provider / month base',
                  '2.5% ops fee on net collections',
                  'Optional +2.5% full RCM add-on',
                  '100% practice ownership retained',
                  'No equity required',
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-gray-700">
                    <i className="ri-check-line text-[#1B4B7F] text-lg flex-shrink-0"></i>
                    {item}
                  </div>
                ))}
              </div>

              <div className="bg-[#F0F7FF] rounded-2xl px-5 py-4 mb-8 text-sm text-gray-600">
                <strong className="text-gray-900">Best for:</strong> Group clinics, multi-provider practices, specialty centers, pharmacies &amp; labs
              </div>

              <div className="flex gap-3">
                <Link to="/mso-pricing" className="flex-1 bg-[#1B4B7F] text-white text-center px-6 py-3.5 rounded-full text-sm font-bold hover:bg-[#153a63] transition-all whitespace-nowrap cursor-pointer">
                  See Full Pricing
                </Link>
                <Link to="/#contact" className="flex-1 border-2 border-[#1B4B7F] text-[#1B4B7F] text-center px-6 py-3.5 rounded-full text-sm font-bold hover:bg-[#F0F7FF] transition-all whitespace-nowrap cursor-pointer">
                  Get a Quote
                </Link>
              </div>
            </div>

            {/* Partnership Model */}
            <div className="rounded-3xl border-2 border-[#059669] bg-[#F0FDF4] p-10 relative flex flex-col">
              <div className="absolute -top-4 left-8 bg-[#059669] text-white px-5 py-1.5 rounded-full text-xs font-bold tracking-widest">
                TRACK 2 — PARTNERSHIP
              </div>
              <div className="absolute top-6 right-6 bg-[#059669] text-white px-3 py-1 rounded-full text-xs font-bold">
                EXCLUSIVE
              </div>
              <div className="mb-6">
                <div className="w-14 h-14 bg-[#059669]/10 rounded-2xl flex items-center justify-center mb-5">
                  <i className="ri-vip-crown-line text-[#059669] text-3xl"></i>
                </div>
                <h2 className="text-3xl font-black text-gray-900 mb-3">Become a Co-Owner</h2>
                <p className="text-gray-600 leading-relaxed">
                  For select single-practice physicians: keep your practice, earn a guaranteed $500K clinical package, and gain 40% equity in MedxMSO. Zero ops fees, zero RCM fees.
                </p>
              </div>

              <div className="space-y-3 mb-8 flex-1">
                {[
                  '$500K guaranteed annual clinical pay',
                  '40% equity ownership in MedxMSO',
                  '0% ops or RCM fees — fully waived',
                  'Onboarding fee waived',
                  '100% practice ownership retained',
                  'Strategic board seat included',
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-gray-700">
                    <i className="ri-check-line text-[#059669] text-lg flex-shrink-0"></i>
                    {item}
                  </div>
                ))}
              </div>

              <div className="bg-white/70 rounded-2xl px-5 py-4 mb-8 text-sm text-gray-600">
                <strong className="text-gray-900">Best for:</strong> Single-practice physicians seeking guaranteed income + long-term equity upside
              </div>

              <div className="flex gap-3">
                <Link to="/partnership" className="flex-1 bg-[#059669] text-white text-center px-6 py-3.5 rounded-full text-sm font-bold hover:bg-[#047857] transition-all whitespace-nowrap cursor-pointer">
                  Learn More
                </Link>
                <Link to="/#contact" className="flex-1 border-2 border-[#059669] text-[#059669] text-center px-6 py-3.5 rounded-full text-sm font-bold hover:bg-[#059669] hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  Schedule a Call
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Side-by-Side Comparison Table */}
      <section className="py-20 bg-[#FAF8F5]">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black text-gray-900 mb-3">Side-by-Side Comparison</h2>
            <p className="text-gray-600">Every key difference between the two models at a glance.</p>
          </div>

          <div className="rounded-3xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="grid grid-cols-3 bg-[#0A1628]">
              <div className="p-5 text-gray-400 text-sm font-semibold">Feature</div>
              <div className="p-5 text-center border-l border-white/10">
                <div className="text-white font-black text-sm mb-0.5">MSO Vendor Model</div>
                <div className="text-gray-400 text-xs">Hire us as your vendor</div>
              </div>
              <div className="p-5 text-center border-l border-white/10 bg-[#059669]/20">
                <div className="text-[#6EE7B7] font-black text-sm mb-0.5">Partnership Model</div>
                <div className="text-green-300 text-xs">Become a co-owner</div>
              </div>
            </div>

            {comparisonRows.map((row, i) => (
              <div key={i} className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                <div className="p-4 text-sm font-semibold text-gray-700">{row.label}</div>
                <div className="p-4 text-center border-l border-gray-100 text-sm text-gray-700">{row.vendor}</div>
                <div className="p-4 text-center border-l border-gray-100 bg-[#F0FDF4]">
                  <span className={`text-sm font-semibold ${row.partnerGood ? 'text-[#059669]' : 'text-gray-700'}`}>{row.partner}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA — Not Sure? */}
      <section className="py-20 bg-[#0A1628]">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Vendor CTA */}
            <div className="bg-white/5 border border-[#1B4B7F]/50 rounded-3xl p-10 flex flex-col">
              <div className="inline-flex items-center gap-2 bg-[#1B4B7F]/30 text-[#93C5FD] px-4 py-1.5 rounded-full text-xs font-bold tracking-widest mb-6 self-start">
                <i className="ri-briefcase-line"></i>
                VENDOR MODEL
              </div>
              <h3 className="text-2xl font-black text-white mb-3">Ready to explore vendor pricing?</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-8 flex-1">
                See the full fee breakdown, Standard vs Full-Service comparison, and use our ROI calculator to estimate your monthly investment.
              </p>
              <Link to="/mso-pricing" className="bg-[#1B4B7F] text-white text-center px-8 py-4 rounded-full text-sm font-bold hover:bg-[#153a63] transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                View Full Vendor Pricing
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Partnership CTA */}
            <div className="bg-[#059669]/10 border border-[#059669]/40 rounded-3xl p-10 flex flex-col">
              <div className="inline-flex items-center gap-2 bg-[#059669]/30 text-[#6EE7B7] px-4 py-1.5 rounded-full text-xs font-bold tracking-widest mb-6 self-start">
                <i className="ri-vip-crown-line"></i>
                PARTNERSHIP MODEL
              </div>
              <h3 className="text-2xl font-black text-white mb-3">Interested in the partnership?</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-8 flex-1">
                Learn how the $500K package and 40% equity structure works, who it's designed for, and how to start a confidential conversation.
              </p>
              <Link to="/partnership" className="bg-[#059669] text-white text-center px-8 py-4 rounded-full text-sm font-bold hover:bg-[#047857] transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                Explore Partnership Model
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="mt-10 text-center">
            <p className="text-gray-500 text-sm mb-4">Still not sure which path fits your practice?</p>
            <Link to="/#contact" className="inline-flex items-center gap-2 bg-white text-[#0A1628] px-8 py-3.5 rounded-full text-sm font-bold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer">
              Talk to Our Team — Free Consultation
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] relative overflow-hidden border-t border-white/5">
        <div className="absolute bottom-0 left-0 right-0 text-[#1A2942] text-[180px] font-bold opacity-50 leading-none select-none pointer-events-none">
          MEDXMSO
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-12">
            <div>
              <div className="text-white text-4xl font-bold mb-3">MedxMSO</div>
              <p className="text-gray-400 text-sm mb-16">Healthcare Management Excellence</p>
              <div className="text-white text-lg leading-relaxed">
                <p>Empowering providers</p>
                <p className="text-gray-400">since 2015</p>
              </div>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Our Services</h4>
              <ul className="space-y-4">
                <li><Link to="/#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Practice Management</Link></li>
                <li><Link to="/#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Revenue Cycle</Link></li>
                <li><Link to="/#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Compliance</Link></li>
                <li><Link to="/#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">HR Solutions</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Pages</h4>
              <ul className="space-y-4">
                <li><Link to="/" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Services</Link></li>
                <li><Link to="/pricing" className="text-[#93C5FD] text-sm hover:text-white transition-colors cursor-pointer">Choose Your Model</Link></li>
                <li><Link to="/mso-pricing" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Vendor Pricing</Link></li>
                <li><Link to="/partnership" className="text-[#6EE7B7] text-sm hover:text-white transition-colors cursor-pointer">Partnership</Link></li>
                <li><Link to="/why-mso" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Why MSO?</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Connect</h4>
              <ul className="space-y-4">
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-linkedin-line text-xl"></i>LinkedIn</a></li>
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-twitter-x-line text-xl"></i>Twitter</a></li>
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-facebook-line text-xl"></i>Facebook</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2024 MedxMSO. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
